export default {
  'zh-CN': {
    selectedAll: '选择全部数据',
    hasBeenSelected: '已选中{n}条',
    hasBeenSelectedData: '已选中{n}条数据',
    theTotalNumberOfArticle: '共{n}条',
    clickLoadMore: '点击加载更多',
    temporarilyNoData: '暂无数据'
  },
  en: {
    selectedAll: 'Select all data',
    hasBeenSelected: '{n} selected',
    hasBeenSelectedData: '{n} selected',
    theTotalNumberOfArticle: '{n} in total',
    clickLoadMore: 'Click to load more',
    temporarilyNoData: 'No Data'
  }
}